<template>
  <div v-if="shouldShow" class="area_location">
    <div class="inr">
      <ol class="location">
        <li class="home">홈</li>
        <li v-for="(bc, i) in crumbsResolved" :key="i">
          {{ bc?.menuNm || '' }}
        </li>
      </ol>

      <div class="util_area">
        <button class="btn_print" type="button" @click="$print()">인쇄하기</button>
        <slot name="util"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue'

defineOptions({name: 'SubHeader'})

/**
 * 주입형 프롭
 * - crumbs: [{ menuNm, item? }] 형태 (nav.breadcrumbs의 shape와 동일)
 * - hideWhenEmpty: 크럼이 비어있으면 감출지 여부
 * - customPrint: 인쇄 버튼 클릭 시 호출할 함수(없으면 window.print)
 */
const props = defineProps({
  title: {type: String, default: ''},
  breadcrumbs: {type: Array, default: null},
  hideWhenEmpty: {type: Boolean, default: true},
  customPrint: {type: Function, default: null},
})

const emit = defineEmits(['print'])

// 주입값 우선
const crumbsResolved = computed(() => {
  if (Array.isArray(props.breadcrumbs)) return props.breadcrumbs
  return []
})

// 표시 여부
const shouldShow = computed(() => props.hideWhenEmpty ? (crumbsResolved.value.length > 0 || props.title) : true)

</script>
